export enum ToggleFilterType {
    Undefined = 0,
    Utm = 1
}
